import { render, staticRenderFns } from "./Shapilov.vue?vue&type=template&id=4bf3f074"
import script from "./Shapilov.vue?vue&type=script&lang=js"
export * from "./Shapilov.vue?vue&type=script&lang=js"
import style0 from "./Shapilov.vue?vue&type=style&index=0&id=4bf3f074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports